import React from "react";
import SelectFor from "components/select/for";
import useTableFilters from "@/hooks/useTableFilters";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";

export default function TagFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      for: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <FilterWrapper label="For">
        <SelectFor
          collection="tags"
          placeholder="Select For"
          value={localFilters?.for?._eq || localFilters?.for}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              for: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
          clearable={true}
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
